/* Globally used components */
import Vue from "vue";
import LoadingSpinner from "@zubut/common/src/components/LoadingSpinner";
import QuickMessage from "@zubut/common/src/components/QuickMessage";
import ZBadge from "@zubut/common/src/components/ZBadge";
import ZButton from "@zubut/common/src/components/ZButton";
import ZIcon from "@zubut/common/src/components/ZIcon";
import ZInput from "@zubut/common/src/components/ZInput";
import ZTabs from "@zubut/common/src/components/ZTabs";
import ZTab from "@zubut/common/src/components/ZTab";

Vue.component("loading-spinner", LoadingSpinner);
Vue.component("quick-message", QuickMessage);
Vue.component("z-badge", ZBadge);
Vue.component("z-button", ZButton);
Vue.component("z-icon", ZIcon);
Vue.component("z-input", ZInput);
Vue.component("z-tabs", ZTabs);
Vue.component("z-tab", ZTab);
